const delay = require('mn-utils/delay');
const CancelablePromise = require('mn-utils/CancelablePromise');

module.exports = (request, timeout, onCheck) => {
  return (params, onUpdate) => {
    return new CancelablePromise((_resolve, _reject) => {
      let _cancel = delay(wait, timeout);
      let _stop;
      function wait() {
        _cancel = request(params)
            .then(next, reject)
            .cancel;
      }
      function resolve(v) {
        _stop = 1;
        _resolve(v);
      }
      function reject(v) {
        _stop = 1;
        _reject(v);
      }
      function next(response) {
        onCheck && onCheck(response, resolve, reject);
        _stop || (
          _cancel = delay(wait, timeout),
          onUpdate && onUpdate(response, resolve, reject)
        );
      }
      return () => {
        _cancel();
      };
    });
  };
};
